import { cx } from '@orn/shared-web/utils/cx';

import type { ConnectionStatus } from '../../hooks/useAssistantWebSocket';

interface IConnectionIndicatorProps {
  status: ConnectionStatus;
}

/**
 * Status dot + label for the assistant WebSocket connection state.
 * Mounted in the assistant pane header.
 */
const ConnectionIndicator = ({ status }: IConnectionIndicatorProps) => {
  const { color, label } = getStatusInfo(status);
  return (
    <div className="flex items-center gap-1.5">
      <div className={cx('size-2 rounded-full', color)} />
      <span className="text-tertiary text-xs">{label}</span>
    </div>
  );
};

function getStatusInfo(status: ConnectionStatus): { color: string; label: string } {
  switch (status) {
    case 'connected':
      return { color: 'bg-success-solid', label: 'Connected' };
    case 'connecting':
      return { color: 'bg-utility-warning-500 animate-pulse', label: 'Connecting' };
    case 'disconnected':
      return { color: 'bg-tertiary', label: 'Disconnected' };
    case 'error':
      return { color: 'bg-error-solid', label: 'Error' };
    default:
      return { color: 'bg-tertiary', label: 'Unknown' };
  }
}

export default ConnectionIndicator;
